import { toast } from "react-toastify";
import {
  addExcelFailure,
  addExcelStart,
  addExcelSuccess,
  fetchDailyGSTReportSheetFailure,
  fetchDailyGSTReportSheetStart,
  fetchDailyGSTReportSheetSuccess,
  fetchDailyReportSheetFailure,
  fetchDailyReportSheetStart,
  fetchDailyReportSheetSuccess,
  fetchLedgerReportSheetFailure,
  fetchLedgerReportSheetStart,
  fetchLedgerReportSheetSuccess,
} from "./reducer";
import {
  getDailyGSTReportService,
  getDailyReportService,
  getLedgerReportService,
  uploadExcelService,
} from "../../Services/ReportService";

// //thunk for fetch the category list
export const fetchDailyGSTReport =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch(fetchDailyGSTReportSheetStart());
      const response = await getDailyGSTReportService(params);

      if (response) {
        // const currentPagination = getState().MealCategory.pagination;
        dispatch(
          fetchDailyGSTReportSheetSuccess({
            report: response,
          })
        );
        const blob = response.data;
        const headers = response.headers;

        let fileName = "DailyTripReport.xlsx";
        const contentDisposition = headers["content-disposition"];
        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?([^"]+)"?/);
          if (match && match.length > 1) {
            fileName = match[1];
          }
        }

        const url = window.URL.createObjectURL(new Blob([blob]));

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName); // Set filename

        // Trigger download
        document.body.appendChild(link);
        link.click();

        // Cleanup
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
        toast.success("Sales Invoice(GST) Report downloaded successfully");
      } else {
        dispatch(fetchDailyGSTReportSheetFailure("No data found"));
      }
    } catch (error) {
      dispatch(fetchDailyGSTReportSheetFailure(error));
    }
  };

export const fetchLedgerReport =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch(fetchLedgerReportSheetStart());
      const response = await getLedgerReportService(params);

      if (response) {
        // const currentPagination = getState().MealCategory.pagination;
        dispatch(
          fetchLedgerReportSheetSuccess({
            report: response,
          })
        );
        const blob = response.data;
        const headers = response.headers;

        let fileName = "DailyTripReport.pdf";
        const contentDisposition = headers["content-disposition"];
        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?([^"]+)"?/);
          if (match && match.length > 1) {
            fileName = match[1];
          }
        }

        const url = window.URL.createObjectURL(new Blob([blob]));

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName); // Set filename

        // Trigger download
        document.body.appendChild(link);
        link.click();

        // Cleanup
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
        toast.success("Ledger Download Successfully");
      } else {
        dispatch(fetchLedgerReportSheetFailure("No data found"));
      }
    } catch (error) {
      dispatch(fetchLedgerReportSheetFailure(error));
    }
  };

export const uploadExcel = (formData) => async (dispatch) => {
  try {
    dispatch(addExcelStart());
    const response = await uploadExcelService(formData);

    if (response) {
      toast.success(response);
      dispatch(addExcelSuccess(response));
    } else {
      toast.error("Something went wrong ");
      dispatch(addExcelFailure("Failed to Upload Excel"));
    }
  } catch (error) {
    toast.error(error);

    dispatch(addExcelFailure(error));
  }
};
